<template>
  <div>
    <b-card title="Site Görseli">
      <b-img
        v-if="dataItem.image3"
        :src="imageUrl + '/media/projects/' + dataItem.image3"
        thumbnail
        center
      />
      <b-button
        v-if="dataItem.image3"
        variant="outline-danger"
        size="sm"
        pill
        class="btn-icon mt-1"
        @click="removeImage(dataItem,'image3','thumb3')"
      >
        <FeatherIcon icon="TrashIcon" />
      </b-button>
      <div class="text-center mt-1">
        <b-button
          variant="primary"
          @click="setModal('projects')"
        >
          <FeatherIcon icon="UploadIcon" />
          Görsel Yüklee
        </b-button>
      </div>
    </b-card>
    <cropper-image
      v-if="cropperSettings.type"
      :modal-status="cropperSettings.modalStatus"
      :close-modal="closeModal"
      :file-name="cropperSettings.fileName"
      :folder="cropperSettings.folder"
      :ratio="cropperSettings.ratio"
      @uploadImage="setUploadImage"
    />
  </div>
</template>
<script>
import { BCard, BImg, BButton } from 'bootstrap-vue'
import CropperImage from '@/layouts/components/common/CropperImage2.vue'
import { required } from '@core/utils/validations/validations'

export default {
  name: 'ImageCard',
  components: {
    BCard,
    BImg,
    BButton,
    CropperImage,
  },
  data() {
    return {
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      },
      required,
      imageUrl: this.$store.state.app.baseURL,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
  },
  methods: {
    setModal(type) {
      if (type === 'projects') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: 'projects-image.jpg',
          folder: 'projects',
          ratio: 1200 / 800, // imagenin çözünürlüğünü yazıyoruz
          type: 'projects',
          width: 500,
        }
      }
    },
    closeModal() {
      this.cropperSettings = {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      }
    },
    setUploadImage(item) {
      this.dataItem.image3 = item.image
      this.dataItem.thumb3 = item.thumb
      this.cropperSettings.modalStatus = false
    },
    removeImage(data, fieldImage, fieldThumb) {
      // console.log(fieldImage, fieldThumb)
      const params = {
        id: data.id,
        dataimage: data.image3,
        folder: 'projects',
        datathumb: data.thumb3,
        fieldImage,
        fieldThumb,
      }
      if (data.id) {
        this.$store.dispatch('projects/removeProjectImageData', params)
          .then(response => {
            if (response) {
              console.log(response)
            }
          })
      } else {
        console.log(data.id)
      }
    },
  },
}
</script>
